const defaultStorage = {
  setItem(key, value) {
    this[key] = value
  },
  getItem(key) {
    return this[key]
  },
  removeItem(key) {
    delete this[key]
  },
}

export default function storage(key, onUpdate, storageType) {
  let localStorage
  try {
    localStorage = global[storageType] ?? global.localStorage ?? defaultStorage
  } catch (e) {
    localStorage = defaultStorage
  }

  const update = (data) => {
    if (typeof onUpdate === 'function') {
      onUpdate(data)
    }
  }

  return {
    save(data, { removeKeys = [] } = {}) {
      let newData = null
      try {
        if (data) {
          const prevProfile = JSON.parse(localStorage?.getItem(key)) || {}
          newData = { ...prevProfile, ...data }
          removeKeys.forEach((field) => delete newData[field])
          localStorage?.setItem(key, JSON.stringify(newData))
        } else {
          localStorage?.removeItem(key)
        }
      } catch (e) {}
      update(newData)
    },
    load() {
      try {
        const info = JSON.parse(localStorage?.getItem(key))
        update(info)
        return info
      } catch (e) {
        console.log('>>> Failed load from localStorage:', key)
      }
      return {}
    },
  }
}
